<h1 mat-dialog-title>Reporte Básico Consolidado</h1>
<div mat-dialog-content>
    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Antecedentes Cliente
                </mat-panel-title>
            </mat-expansion-panel-header>
            <app-ant-consolidado [rut]="rut" [reporteFull]="dataServicios?.consolidadoTitular"></app-ant-consolidado>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="dataServicios?.deudaSbif?.reporte">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Deuda Sbif
                </mat-panel-title>
            </mat-expansion-panel-header>
            <app-deuda-leasing-sbif-viewer [content]='dataServicios?.deudaSbif?.reporte' [typeTX]="false" [showHeader]="false"></app-deuda-leasing-sbif-viewer>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cerrar</button>
</div>
